export default "__VITE_ASSET__BsL6LYtg__"